import React from "react";
import {Redirect, Route} from "react-router-dom";
import {USER_KEY} from "../helpers/TokenHelper";

function ProtectedRoute({component: Component, isUserLoggedIn, ...restOfProps}) {
    const isAuthenticated = () => {
        let user = JSON.parse(localStorage.getItem(USER_KEY));
        if (user) {
            return user.x !== '';
        }
        return false;
    }

    return (
        <Route
            {...restOfProps}
            render={(props) => isAuthenticated ? <Component {...props} /> : <Redirect to="/login"/>}
        />
    );
}

export default ProtectedRoute;
